// import './sass/all.scss';
// import $ from "jquery";
// window.$ = window.jQuery = $;
// import barba from "@barba/core";
import "bootstrap";

import "slick-carousel";

// import svgPanZoom from "svg-pan-zoom";
// import Hammer from "hammerjs";

// import checkAddress from './checkaddress'

import {
  TimelineMax,
  TweenMax,
  TweenLite,
  Linear,
  Power2,
  Power4,
  Expo,
  gsap,
} from "gsap";

import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
// gsap.registerPlugin(SplitText);


const body = document.querySelector("body");

const twInnerHeight = () => {
  if (document.querySelectorAll(".h-screen") != null) {
    const h_screen = document.querySelectorAll(".h-screen");
    h_screen.forEach((item)=>{
      item.style.height = window.innerHeight + "px";
    });
  }
}

const articleEmbeds = () => {
  if (document.querySelectorAll(".article_embed iframe") != null) {
    const articleEmbeds = document.querySelectorAll('.article_embed iframe');
    articleEmbeds.forEach((ele)=>{
      ele.style.height = ele.offsetWidth * 0.5625 + 'px';
    });
  }
}

const sectionInView = () => {
  if (document.querySelector(".section_fade_in") != null){
    setTimeout(()=>{
      document.querySelectorAll(".section_fade_in")[0].classList.add("enter");
    }, 1500);
    document.querySelectorAll(".section_fade_in").forEach((item) => {
      if (item.getBoundingClientRect().y - window.innerHeight * 0.85 < 0) {
        item.classList.add("enter");
      } else {
        // item.classList.remove("enter");
      }
    });
  }
}

const shopContainer = () => {
  const shopContainer = document.querySelector('.shop_container');
  if (shopContainer != null){
    const shopContainerStyle = shopContainer.currentStyle || window.getComputedStyle(shopContainer);
    const navList = document.querySelector('.nav_list');
    
    if (window.innerWidth > 959){
      shopContainer.style.paddingLeft = navList.getBoundingClientRect().x + navList.getBoundingClientRect().width - parseInt(shopContainerStyle.marginLeft, 10) + 'px';
    } else {
      shopContainer.style.paddingLeft = navList.getBoundingClientRect().x + 'px';
    }
  }
}

const homeContentContainer = () => {
  const homeContentContainer = document.querySelector('.home_content_container');

  if (homeContentContainer != null){
    const shopContainerStyle = homeContentContainer.currentStyle || window.getComputedStyle(homeContentContainer);
    const navList = document.querySelector('.nav_list');
    
    if (window.innerWidth > 959){
      homeContentContainer.style.paddingLeft = navList.getBoundingClientRect().x + navList.getBoundingClientRect().width - parseInt(shopContainerStyle.marginLeft, 10) + 'px';
      homeContentContainer.style.paddingRight = navList.getBoundingClientRect().x + navList.getBoundingClientRect().width - parseInt(shopContainerStyle.marginLeft, 10) + 'px';
    } else {
      homeContentContainer.style.paddingLeft = navList.getBoundingClientRect().x + 'px';
    }
  }
}

const navHasSubList = () => {
  const subLists = document.querySelectorAll('.has_sub_list');
  subLists.forEach((subList)=>{
    const subListTitle = subList.querySelector('.sub_list_title');
    const subListIcon = subList.querySelector('.sub_list_icon');
    const subListContainer = subList.querySelector('.sub_list_container');
    const subListItems = subListContainer.querySelectorAll('.sub_list_item');
    const subListContainerHeight = subListItems[0].offsetHeight * subListItems.length + 'px';
    subListTitle.addEventListener('click', ()=>{
      subList.classList.toggle('active');
      subListIcon.classList.toggle('-rotate-180');
      if (subListContainer.offsetHeight == 0){
        subListContainer.style.height = subListContainerHeight;
      } else {
        subListContainer.style.height = '0px';
      }
    });
  });
}


const addOnContainerSwitch = () => {
  if ( document.querySelector('.product_add_on_wrap') != null ){
    const addOnWrap = document.querySelector('.product_add_on_wrap');

    if ( document.querySelector('.add_on_btn') != null ){
      const addOnBtn = document.querySelector('.add_on_btn');
      addOnBtn.addEventListener('click', ()=>{
        addOnWrap.classList.toggle('active');
        body.classList.toggle('overflow-hidden');
      });
    }

    if ( document.querySelector('.close_btn') != null ){
      const addOnCloseBtn = addOnWrap.querySelector('.close_btn');
      addOnCloseBtn.addEventListener('click', ()=>{
        addOnWrap.classList.toggle('active');
        body.classList.toggle('overflow-hidden');
      });
    }

  }
}

const cartContainerSwitch = () => {
  if (document.querySelector('.cart_wrap') != null){
    const cartBtn = document.querySelector('.cart_btn');
    const cartWrap = document.querySelector('.cart_wrap');
    const cartCloseBtn = cartWrap.querySelector('.back');
    const cartBackCover = cartWrap.querySelector('.cart_back_cover');
    if(document.querySelector('.cart_btn') != null){
      cartBtn.addEventListener('click', ()=>{
        cartWrap.classList.toggle('active');
        // body.classList.toggle('overflow-hidden');
      });
    }
    cartCloseBtn.addEventListener('click', ()=>{
      cartWrap.classList.toggle('active');
      // body.classList.toggle('overflow-hidden');
    });
    cartBackCover.addEventListener('click', ()=>{
      cartWrap.classList.toggle('active');
      // body.classList.toggle('overflow-hidden');
    });
  }
}

const navFunction = () => {
  const nav = document.querySelector(".nav");

  if (document.querySelector(".nav_btn") != null){
    const navBtn = nav.querySelector(".nav_btn");
    navBtn.addEventListener('click', ()=>{
      nav.classList.toggle('active');
      if (document.querySelector(".home_container") != null){
        if (nav.classList.contains('active')){
          nav.classList.remove('onLeave');
        } else {
          nav.classList.add('onLeave');
        }
      } else {
        nav.classList.toggle('bg-back');
        if (nav.classList.contains('active')){
          nav.classList.remove('onLeave');
          body.classList.add('overflow-hidden');
        } else {
          nav.classList.add('onLeave');
          body.classList.remove('overflow-hidden');
        }
      }
      if (document.querySelector(".nav_menu") != null){
        const navMenu = document.querySelector(".nav_menu");
        const navList = navMenu.querySelector(".nav_list");
        navMenu.classList.toggle('opacity-0');
        navList.classList.toggle('pointer-events-none');
        navList.classList.toggle('pointer-events-auto');
      }
    });
  }
}

const productPhotoSlide = () => {
  var productPhotos = document.querySelectorAll(".product_photo");
  var originalPhoto = document.querySelector(".original_photo");

  if (productPhotos.length != 0 && originalPhoto != null){

    originalPhoto.classList.add('duration-300');

    productPhotos.forEach((photo)=>{
      photo.addEventListener('click', (item)=>{
        originalPhoto.classList.add('opacity-0');
        // productPhotos.forEach((item)=>{ item.classList.add('grayscale') });
        // console.log(photo.src);
        setTimeout(()=>{
          // if (photo.src == originalPhoto.src){
            originalPhoto.src = photo.src;
            // photo.src = photo.dataset.original;
          // } else {
            // originalPhoto.src = photo.src;
            // photo.src = originalPhoto.dataset.original;
            // photo.classList.toggle('grayscale');
          // }  
        }, 200);

        setTimeout(()=>{
          originalPhoto.classList.remove('opacity-0');
        }, 250);
      });
    });
      
  }
}


const formRadio = () => {
  const formRadioItem = document.querySelectorAll(".form_radio_item");

  if (formRadioItem[0] != null){

    formRadioItem.forEach((item, key)=>{
      const label = item.querySelector("label");
      label.addEventListener('click', ()=>{
        formRadioItem.forEach((r)=>{ r.classList.remove('active'); });
        item.classList.toggle('active');
      });
    });
  
    formRadioItem[0].querySelector("label").click();

  }
}

const formNumber = () => {
  const formNumberItem = document.querySelectorAll(".form_number_box");
  formNumberItem.forEach((item, key)=>{
    // console.log(item);
    const minus = item.querySelector(".minus");
    const plus = item.querySelector(".plus");
    const formNumber = item.querySelector(".form_number");

    if (minus != null){
      const hiddenQuantity = item.querySelector(".hidden_quantity input.qty");
      minus.addEventListener('click', ()=>{
        formNumber.stepDown();
        hiddenQuantity ? hiddenQuantity.value = formNumber.value : '';
      });
    }
    if (plus != null){
      const hiddenQuantity = item.querySelector(".hidden_quantity input.qty");
      plus.addEventListener('click', ()=>{
        formNumber.stepUp();
        hiddenQuantity ? hiddenQuantity.value = formNumber.value : '';
      });
    }

  });
}

const floristFormRadio = () => {
  const formRadioItem = document.querySelectorAll(".form_radio_item");
  const priceMeta = document.querySelector(".price_meta");
  const addToCartButton = document.querySelector(".single_add_to_cart_button");
  document.querySelector('.product_detail input#florist_start_date').required = true;
  // var productID = '';

  if (priceMeta != null){
    const price = priceMeta.querySelector(".price");
    const unit = priceMeta.querySelector(".unit");
    
    formRadioItem.forEach((item, key)=>{
      var label = item.querySelector("label");
      var inputPrice = item.querySelector("input").dataset.price;
      var inputUnit = item.querySelector("input").dataset.unit;
      var productID = item.querySelector("input").dataset.product_id;
      var week = item.querySelector("input").dataset.week;
      // console.log(inputPrice + '-' + productID);
      label.addEventListener('click', ()=>{
        // priceMeta.classList.add('opacity-0');
        addToCartButton.value = productID;

        const forSubscription = document.querySelectorAll('.product_detail .for_subscription');
        const forSimple = document.querySelectorAll('.product_detail .for_simple');
        if (item.classList.contains('subscription')){
          forSubscription.forEach((item)=>{
            item.classList.add('active');
            item.classList.remove('hidden');
          })
          forSimple.forEach((item)=>{
            item.classList.add('hidden');
            item.classList.remove('active');
          })
          document.querySelector('.product_detail input#florist_start_date').value = '';
          document.querySelector('.product_detail input#florist_start_date').required = false;
          document.querySelector('.product_detail input#florist_subscription_start_date').required = true;
        } else {
          forSubscription.forEach((item)=>{
            item.classList.remove('active');
            item.classList.add('hidden');
          })
          forSimple.forEach((item)=>{
            item.classList.remove('hidden');
            item.classList.add('active');
          })
          document.querySelector('.product_detail input#florist_subscription_start_date').value = '';
          document.querySelector('.product_detail input#florist_subscription_start_date').required = false;
          document.querySelector('.product_detail input#florist_start_date').required = true;
        }

        // addToCartButton.href = '/cart/?add-to-cart=' + productID + '&quantity=' + productQuantityNumber.value;
        // setTimeout(()=>{
        //   price.textContent = inputPrice;
        //   unit.textContent = inputUnit;
        //   priceMeta.classList.remove('opacity-0');
        // }, 200);
      });
    });

    // addToCartButton.addEventListener('mouseenter', updateAddToCartButton);
    // addToCartButton.addEventListener('touchstart', updateAddToCartButton);

    // function updateAddToCartButton(){
      // const productID = document.querySelector('.form_radio_item.active input').dataset.product_id;
      // const productQuantityNumber = document.querySelector(".product_quantity .form_number");
      // addToCartButton.href = '/cart/?add-to-cart=' + productID + '&quantity=' + productQuantityNumber.value;
      // addToCartButton.value = productID;
    // }

    // productQuantitySpinBtn.forEach((item, key)=>{
    //   item.addEventListener('click', ()=>{
    //     addToCartButton.href = '/cart/?add-to-cart=' + productID + '&quantity=' + productQuantityNumber.value;
    //   })
    // });
  }

}

const addOnProduct = () => {
  const addOnProduct = document.querySelectorAll(".add_on_product_item");
  if ( addOnProduct.length != 0 ){
    addOnProduct.forEach((item)=>{
      var quantity = item.querySelector(".form_number");
      if (quantity != null){
        var spinBtn = item.querySelectorAll(".spin_btn");
        var addOnProductBtn = item.querySelector(".add_on_product_btn");
        addOnProductBtn.dataset.quantity = quantity.value;
        spinBtn.forEach((itemBtn)=>{
          itemBtn.addEventListener('click', ()=>{
            addOnProductBtn.dataset.quantity = quantity.value;
          });
        });
      }
    });

    
    $('.add_on_product_item .add_on_check').on('change', function(){
      if ($('.add_on_product_item .add_on_check').is(":checked") == true){
        $('.product_add_on_wrap .add_on_done').addClass('active');
        $('.product_add_on_wrap .close_inner').removeClass('active');
      } else {
        $('.product_add_on_wrap .add_on_done').removeClass('active');
        $('.product_add_on_wrap .close_inner').addClass('active');
      }
    })

    function add_on_count(){
      var countProductQty = '';
      $('.cart_product_list .cart_item .qty').each(function(){
        var productQty = Number($(this).val());
        countProductQty = parseInt(productQty + countProductQty);
      });
      $('.add_on_cart_count').text(countProductQty);
    }
    add_on_count();




    $('.add_on_done').on('click', function(e){ 
      var addOnArray = [], i = 0;
      $('.add_on_product_item').each(function(){
        var addOnProductCheck = $(this).find('.add_on_check');
        var addOnProduct = $(this).find('.add_on_product_btn');
        var productID = addOnProduct.data('product_id') || 0;
        var productQty = addOnProduct.data('quantity') || 0;
        var variationID = addOnProduct.data('variation_id') || 0;
        if (addOnProductCheck.is(":checked") == true){
          addOnArray[i++] = {id: productID, qty: productQty, variation: variationID};
        }
      });
      $.ajax({
        type: 'post',
        url: wc_add_to_cart_params.ajax_url,
        data: {
          action: 'ql_woocommerce_ajax_add_to_cart',
          add_on_array: addOnArray,
        },
        beforeSend: function (response) {
        },
        complete: function (response) {

          var link = $('.add_on_done').data("href");
          window.location.href = link;

        }, 
        success: function (response) {
          console.log(response);

          if ( $('.weekly_website').length != 1 ){

            var newCart = response.fragments["div.widget_shopping_cart_content"];
            var cartTotal = response.fragments.cart_totals;
            
            $('.cart_product_list *').remove();
            $('.cart_product_list').append(newCart);
            $('.cart_product_list .widget_shopping_cart_content .product_item').unwrap();
  
            formNumber();
  
            $('.cart_count').text(response.fragments.cart_count);
  
            $('.cart_totals *').remove();
            $('.cart_totals').append(cartTotal);
  
            // $('.add_on_cart_count').text(response.fragments.cart_count - 1);
            add_on_count();
  
            if (response.error & response.product_url) {
              window.location = response.product_url;
              return;
            } else { 
              // $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $thisbutton]);
            } 
          }

          // console.log(addOnArray);

        }, 
      });

    });
  }
}

const checkoutCoupon = () => {
  const checkoutCoupon = document.querySelectorAll('.woocommerce-remove-coupon .icon');
  if (checkoutCoupon.lenght != 0){
    checkoutCoupon.forEach((ele)=>{
      ele.addEventListener('click', ()=>{
        setTimeout(()=>{
          location.reload();
        }, 500);
      })
    })
  }
}

const notice = () => {
  const noticeWrap = document.querySelectorAll('.woocommerce-notice-wrap');
  if (noticeWrap.lenght != 0){
    noticeWrap.forEach((ele)=>{
      const close = ele.querySelector('.notice_close');
      close.addEventListener('click', ()=>{
        ele.classList.add('fade_hidden')
      });
    })
  }
}

const ajaxCheckoutLogin = () => {
  $("form#checkout_login .submit_button").on("click", function (e) {
    console.log('login');
    console.log(ajax_login_object.loadingmessage);
    // console.log('login');
    $("form#checkout_login p.status")
      .show()
      .text(ajax_login_object.loadingmessage);
    $.ajax({
      type: "POST",
      dataType: "json",
      url: ajax_login_object.ajaxurl,
      data: {
        action: "ajaxlogin", //calls wp_ajax_nopriv_ajaxlogin
        username: $("form#checkout_login #username").val(),
        password: $("form#checkout_login #password").val(),
        security: $("form#checkout_login #security").val(),
      },
      success: function (data) {
        $("form#checkout_login p.status").text(data.message);
        if (data.loggedin == true) {
          document.location.href = document.location.href;
        }
      },
    });
    e.preventDefault();
  });
}


const floristAjaxResetCart = () => {
  console.log(performance.getEntriesByType("navigation")[0].type);
  window.onpageshow = function(event) {
    if (event.persisted) {
      // console.log('safari');
      $.ajax({
        type: "POST",
        dataType: "json",
        url: woocommerce_params.ajax_url,
        data: {
          action: "ajax_reset_cart", //calls wp_ajax_nopriv_ajaxlogin
        },
        success: function(data) {
          // alert('reset cart');
          window.location.reload();
          // if (data.status 5= true) {
          //   console.log(data.status);
          // }
        },
      });
    }
  };

  // if (window.performance && window.performance.navigation.type === window.performance.navigation.TYPE_BACK_FORWARD) {
  //   $.ajax({
  //     type: "POST",
  //     dataType: "json",
  //     url: woocommerce_params.ajax_url,
  //     data: {
  //       action: "ajax_reset_cart", //calls wp_ajax_nopriv_ajaxlogin
  //     },
  //     success: function(data) {
  //       // alert('reset cart');
  //       window.location.reload();
  //       // if (data.status 5= true) {
  //       //   console.log(data.status);
  //       // }
  //     },
  //   });
  // }

  let previous_page_url = document.referrer;
  let result = previous_page_url.includes('checkout') || previous_page_url.includes('cart');
  if (result == true){
    $.ajax({
      type: "POST",
      dataType: "json",
      url: woocommerce_params.ajax_url,
      data: {
        action: "ajax_reset_cart", //calls wp_ajax_nopriv_ajaxlogin
      },
      success: function(data) {
        // alert('reset cart');
        // window.location.reload();
        // if (data.status == 5rue) {
        //   console.log(data.status);
        // }
      },
    });
  }


}

const floristAjaxAddOns = () => {
  // console.log('before submit');
  // $('.cart').click(function(){
  //   console.log('submit');
  //   $.ajax({
  //     type: "POST",
  //     dataType: "json",
  //     url: woocommerce_params.ajax_url,
  //     data: {
  //       action: "ajax_add_to_cart", //calls wp_ajax_nopriv_ajaxlogin
  //     },
  //     success: function(data) {
  //       // alert('reset cart');
  //       // window.location.reload();
  //       // if (data.status == 5rue) {
  //         console.log(data.status);
  //       // }
  //     },
  //   });
  // });
}

const floristcheckoutInputSync = () => {

  $('#billing_first_name').val($('#input_billing_first_name').val());
  $('#billing_email').val($('#input_billing_email').val());
  $('#billing_phone').val($('#input_billing_phone').val());

  $('#input_shipping_first_name').val($('#shipping_first_name').val());
  $('#input_shipping_phone').val($('#shipping_phone').val());
  $('#input_street_address').val($('#shipping_address_1').val());

  $('#input_billing_first_name').on('input', function() {
    $('#billing_first_name').val($(this).val());
  });

  $('#input_billing_email').on('input', function() {
    $('#billing_email').val($(this).val());
  });

  $('#input_billing_phone').on('input', function() {
    $('#billing_phone').val($(this).val());
  });

  $('#input_shipping_first_name').on('input', function() {
    $('#shipping_first_name').val($(this).val());
  });
  
  $('#input_shipping_phone').on('input', function() {
    $('#shipping_phone').val($(this).val());
  });

  $('#input_street_address').on('input', function() {
    $('#shipping_address_1').val($(this).val());
  });

  $('#input_second_name').on('input', function() {
    $('#second_name').val($(this).val());
  });

  $('#input_second_phone').on('input', function() {
    $('#second_phone').val($(this).val());
  });

  $('#input_second_phone').on('input', function() {
    $('#second_phone').val($(this).val());
  });

  $('#input_shipping_delivery_time').on('input', function() {
    $('#delivery_time').val($(this).val());
  });

  $('#input_message_card').on('input', function() {
    $('#message_card').val($(this).val());
  });

  $('#shipping_state').appendTo('.form_select_city');
  $('#shipping_state').addClass('form_select');

  $('#shipping_city').appendTo('.form_select_district');
  $('#shipping_city').addClass('form_select');

  $('.woocommerce-checkout-payment').appendTo('.side_payment');

  $('#cw-pay2go-ei_fields').appendTo('.input_cw_pay2go');
  $('#cw-pay2go-ei_fields select').addClass('form_select');
  $('#cw-pay2go-ei_fields input').addClass('sub_form_input sm w-3/4 md:w-1/2');
  $('#cw-pay2go-ei_fields .description').addClass('ml-2 text-xs text-black/80');
  $('#cw-pay2go-ei_fields label').addClass('text-s mb-2 block');


  if ($('.variation-florist_subscription_start_date').length > 0){
    $('.subscription_tip').removeClass('hidden');
  } else if ($('.variation-florist_subscription_start_date').length == 0){
    $('.subscription_tip').remove();
  }
}

const floristProductOption = () => {

  $('.form_radio_group .form_radio_item').click(function(){
    $('#size').val($('input[name=size]:checked').val());
  });
  
  $('.input_quantity').on('input', function() {
    $('.main_product_quantity .qty').val($(this).val());
  });

  $('#input_florist_shipping').on('input', function() {
    $('#florist_shipping').val($(this).val());
  });
  
  $('.input_frequency').on('input', function() {
    var input_frequency = $('.input_frequency.active');
    var florist_payment_frequency = $('input#florist_payment_frequency');
    florist_payment_frequency.val(input_frequency.val());

    if ( $('.for_subscription').hasClass('active') ) {
      console.log(input_frequency.find(':selected').data('id'));
      $('.single_add_to_cart_button').val( input_frequency.find(':selected').data('id') );
    }
  });
  
  $('.main_quantity').addClass('hidden');
  $('.product_detail .main_quantity .main_product_quantity').appendTo('.input_quantity');
  
  $('.extra-options input#florist_start_date').appendTo('.input_florist_date');
  $('.extra-options input#florist_subscription_start_date').appendTo('.input_florist_date');
  
  $("form.cart").prepend( $('.product_detail_options') );

  $('.cart').submit(function(e){
    $('#florist_shipping').val($('#input_florist_shipping').val());
    $('#florist_shipping_last_date').val($('.hasDatepicker.active').val());
    $('#florist_shipping_times').val($('.form_radio_item.active input').data('week'));
    $('#florist_payment_frequency').val($('.input_frequency.active').val());

    if ( !$('#florist_start_date').val() && !$('#florist_subscription_start_date').val() ){
      e.preventDefault();
      alert('請選擇開始日期 (begin date)。');
      // console.log('1')
    } else {
      // e.preventDefault();
      // console.log('2')
    }

  });
}

const sectionFadeIn = () => {
  
  gsap.utils.toArray(".section_fade_in").forEach(function(elem) {
    ScrollTrigger.create({
      trigger: elem,
      invalidateOnRefresh: true,
      // pin: true,
      // scrub: true,
      start: () => "-=" + window.innerHeight * 0.6,
      // end: () => "+=" + window.innerHeight * 0.4,
      // markers: true,
      onEnter: function() { 
        gsap.to(elem, {
          autoAlpha: 1,
          duration: 1.5,
          // delay: .2,
          ease: Power4.easeOut
        });
      }
    });
  });
  
}


const homePage = () => {

  if ($(".hero_photo_slide").length == 1) {
    $(".hero_photo_slide").slick({
      //dots: true,
      infinite: true,
      speed: 3000,
      fade: true,
      arrows: false,
      autoplay: true,
      autoplaySpeed: 6000,
      slidesToShow: 1,
      slidesToScroll: 1,
      // useTransform: false,
      // useCSS: false,
    });
  }

  // homeContentContainer();

  if ( $('.hero_photo_slide').length != 0 ){
    gsap.to('.nav, .nav_menu', {
      // transform: "translate(0%, 0%)",
      // clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
      // opacity: 1,
      // ease: Power2.easeOut,
      scrollTrigger: {
        trigger: '.hero_photo_slide',
        invalidateOnRefresh: true,
        scrub: true,
        start: "top top",
        end: "bottom top",
        // markers: true,
        onEnter: function() {
          // console.log('on Enter') ;
          $('.nav, .nav_menu').addClass('onCover');
          $('.nav').removeClass('bg-back');
        }, 
        onEnterBack: function() {
          // console.log('on Enter back')  ;
          $('.nav, .nav_menu').addClass('onCover');
          $('.nav').removeClass('bg-back');
        },
        onLeave: function() {
          // console.log('on Leave') ;
          $('.nav, .nav_menu').removeClass('onCover');
          $('.nav').addClass('bg-back');
        }, 
        onLeaveBack: function() {
          // console.log('on Leave back')  ;
          $('.nav, .nav_menu').removeClass('onCover');
          // $('.nav').addClass('onLeave');
        },
      }
    });
  }
}



const counttime_data = () => {
  
  if ( $('.counttime_data').length != 0 ){

    var date_text = document.querySelector(".counttime_data");

      var calcNewYear = setInterval(function(){
        var year = date_text.dataset.year;
        var month = date_text.dataset.month - 1;
        var date = date_text.dataset.date;
        var hour = date_text.dataset.hour - 1;
        var min = date_text.dataset.min - 1;
        var sec = date_text.dataset.sec;

        var date_future = new Date(year, month, date, hour);
        date_future.toLocaleString('zh-TW', {timeZone: 'Asia/Taipei'});
        var date_now = new Date();
        date_now.toLocaleString('zh-TW', {timeZone: 'Asia/Taipei'});
        // console.log(date_future + ' - ' + date_now);
        
        var seconds = Math.floor((date_future - (date_now))/1000);
        var minutes = Math.floor(seconds/60);
        var hours = Math.floor(minutes/60);
        var days = Math.floor(hours/24);

        var hours = hours - (days*24);
        var minutes = minutes - (days*24*60) - (hours*60);
        var seconds = seconds - (days*24*60*60) - (hours*60*60) - (minutes*60);

        var hours = hours < 10 ? '0' + hours : hours;
        var minutes = minutes < 10 ? '0' + minutes : minutes;
        var seconds = seconds < 10 ? '0' + seconds : seconds;

        document.querySelector(".counttime_data").textContent = days + " days 　" + hours + ":" + minutes + ":" + seconds;
    }, 1000);
  }

}




const selectCheckoutInputSync = () => {

  $('#billing_first_name').val($('#input_billing_first_name').val());
  $('#billing_email').val($('#input_billing_email').val());
  $('#billing_phone').val($('#input_billing_phone').val());

  $('#input_shipping_first_name').val($('#shipping_first_name').val());
  $('#input_shipping_phone').val($('#shipping_phone').val());
  $('#input_street_address').val($('#shipping_address_1').val());

  $('#input_billing_first_name').on('input', function() {
    $('#billing_first_name').val($(this).val());
  });

  $('#input_billing_email').on('input', function() {
    $('#billing_email').val($(this).val());
  });

  $('#input_billing_phone').on('input', function() {
    $('#billing_phone').val($(this).val());
  });

  $('.shipping_text').html($('input[name="shipping_method[0]"]:checked').next().html());

  if ( $('input[name="shipping_method[0]"]:checked').val() == 'cw-ecpay:4' ){
    if ( $('.shipment .shipment_inner').hasClass('hidden') ){
      // $('.shipment .shipment_inner').removeClass('hidden');
    }
  } else {
    $('.shipment .shipment_inner').removeClass('hidden');
  }

  $('input[name="shipping_method[0]"]').change(function(){
    $('.shipping_text').html($('input[name="shipping_method[0]"]:checked').next().html());
    if ( this.value == 'cw-ecpay:4' ){
      if ( $('#cw-ecpay_choose-store').length == 0 ){
        setTimeout(function(){
          location.reload();
        }, 500);
      }
    } else {
      if ( $('.shipment .shipment_inner').hasClass('hidden') ){
        $('.shipment .shipment_inner').removeClass('hidden');
      } else {
        $('.shipment .shipment_inner').addClass('hidden');
      }
    }
  });

  $('#input_shipping_first_name').on('input', function() {
    $('#shipping_first_name').val($(this).val());
  });
  
  $('#input_shipping_phone').on('input', function() {
    $('#shipping_phone').val($(this).val());
  });

  $('#input_street_address').on('input', function() {
    $('#shipping_address_1').val($(this).val());
  });

  $('#shipping_state').appendTo('.form_select_city');
  $('#shipping_state').addClass('form_select');

  $('#shipping_city').appendTo('.form_select_district');
  $('#shipping_city').addClass('form_select');

  $('.woocommerce-checkout-payment').appendTo('.side_payment');

  $('#cw-pay2go-ei_fields').appendTo('.input_cw_pay2go');
  $('#cw-pay2go-ei_fields select').addClass('form_select');
  $('#cw-pay2go-ei_fields input').addClass('sub_form_input sm w-3/4 md:w-1/2');
  $('#cw-pay2go-ei_fields .description').addClass('ml-2 text-xs text-black/80');
  $('#cw-pay2go-ei_fields label').addClass('text-s mb-2 block');

}



function loaded() {

  twInnerHeight();
  shopContainer();
  // sectionFadeIn();

  navFunction();
  navHasSubList();
  
  addOnContainerSwitch();
  cartContainerSwitch();
  
  productPhotoSlide();

  formRadio();
  formNumber();

  addOnProduct();

  notice();

  ajaxCheckoutLogin();
  checkoutCoupon();


  if ( $('.weekly_website').length != 0 ){

    homePage();
    
    if ( $('.single_product_container').length != 0 ){

      floristFormRadio();
      floristProductOption();
      floristAjaxResetCart();

      floristAjaxAddOns();

      $('.shipping_check_address').click(function(){

        function scroll_to_check(){
          window.scrollTo({
            top: document.querySelector('#checkAddressWrap').offsetTop - 80, 
            behavior: 'smooth'
          });
        }
        
        if ( $('.panel_inner_group:nth-child(2) .panel_collapse').hasClass('show') ){
          scroll_to_check();
        } else {
          $('.panel_inner_group:nth-child(2) .panel_title a').trigger('click');
          setTimeout(() => {
            scroll_to_check()
          }, 300);
        }

      });

      $('form.cart').attr('autocomplete', 'off');

      $('.price_meta .price').text($('.form_radio_item:nth-child(1) input').data('price'));
      $('.price_meta .unit').text($('.form_radio_item:nth-child(1) input').data('unit'));

      $('.cart input, .cart select, .cart .spin_btn').on('click input', function() {

        // console.log($(this));

        if ( $('.input_florist_shipping').val() ==  'pickup' ){
          var shipping_fee = '0';
        } else if ( $('.input_florist_shipping').val() ==  'taipei' ){
          var shipping_fee = '100';
        } else if ( $('.input_florist_shipping').val() ==  'taiwan' ){
          var shipping_fee = '350';
        }
        
        if ( $('.input_florist_shipping').val() ==  'pickup' ){
          var shipping_fee = '0';
        } else if ( $('.input_florist_shipping').val() ==  'taipei' ){
          var shipping_fee = '150';
        } else if ( $('.input_florist_shipping').val() ==  'taiwan' ){
          var shipping_fee = '350';
        }
    
        var a_week = $('.form_radio_item.active input').data('week');
        if ( a_week ==  '1' ){
          var weeks = '1';
          $('.item_frequency').addClass('opacity-50 pointer-events-none');
        } else if ( a_week ==  '4' ){
          var weeks = '4';
          $('.item_frequency').removeClass('opacity-50 pointer-events-none');
        } else if ( a_week ==  'subscription' ){
          var weeks = '1';
          $('.item_frequency').removeClass('opacity-50 pointer-events-none');
        }

        var price = $('.form_radio_item.active input[name=florist_weeks]').data('price').substring(1);
        var quantity = $('.input_quantity input').val();

        var new_shipping = (price * quantity) + (shipping_fee * weeks * quantity);
        var new_unit = $('.form_radio_item.active input').data('unit');

        // console.log(price);
        // console.log(quantity);
        // console.log(shipping_fee);
        // console.log(weeks);
        // console.log(new_shipping);

        $('.price_meta .price').text('$' + new_shipping);
        $('.price_meta .unit').text(new_unit);

    
      });
    }

    if ( $('.page_checkout_container').length != 0 ){

      floristcheckoutInputSync();
  
      $('form[name="checkout"]').submit(function(e){
        var formId = this.id,
            form = this;

        $('.address_check').trigger('click');
        e.preventDefault();

        if ( !$('.input_checkaddress').is(':checked') ){
          $('.checkout .submit_button').addClass('disable');
        }
      });
      
    }
    
    if ( $('.archive_product_container').length != 0 ){

      $('.nav_list_container .list_item:nth-child(1) .sub_list_title').trigger('click');

    }

  }

  if ( $('.page_customer_login').length != 0 ){

    $('.register_switch').click(function(){
      $('.checkout_form').addClass('hidden');
      $('.register_form').removeClass('hidden');
    });

    if ( location.hash == '#signup' ){
      $('.checkout_form').addClass('hidden');
      $('.register_form').removeClass('hidden');
    }
    
  }

  $('.single_add_to_cart_button').addClass('btn_submit');





  

  if ( $('.select_website').length != 0 ){

    homePage();

    if ( $('.single_product_container').length != 0 ){

      $('.product_detail_options .main_quantity').after($('.product_detail_options .note'));
      $('.product_detail_options .note').after($('.product_detail_options .counttime'));

      counttime_data();

    }

    if ( $('.page_checkout_container').length != 0 ){

      selectCheckoutInputSync();

    }

  }


  // photoSlide();
  // articleEmbeds();

}

document.addEventListener("DOMNodeInserted", function() {
  notice();
});

document.addEventListener("DOMContentLoaded", function() {
  loaded();
  sectionInView();
  // chackAddress
});

window.addEventListener("scroll", function() {
  sectionInView();
});

window.addEventListener("resize", function() {
  twInnerHeight();
  shopContainer();
});
